import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { toast } from 'sonner'
import { useAuth } from '@/hooks/useAuth'
import Loading from '@/components/common/Loading'
import { ADMIN_EMAIL_ALLOWLIST } from '@/lib/config'

const createAllowlistSet = (() => {
  let cached
  return () => {
    if (!cached) {
      cached = new Set(ADMIN_EMAIL_ALLOWLIST)
    }
    return cached
  }
})()

function ProtectedRoute({ children, adminOnly = false, featureFlag = true }) {
  const { isAuthenticated, loading, user } = useAuth()
  const location = useLocation()

  if (!featureFlag) {
    return <FeatureDisabledRedirect />
  }

  if (loading) {
    return <Loading text="Checking authentication..." />
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth?tab=signin" replace state={{ from: location.pathname }} />
  }

  if (adminOnly) {
    const allowlist = createAllowlistSet()
    const email = user?.email?.toLowerCase()
    if (!email || !allowlist.has(email)) {
      return <UnauthorizedRedirect />
    }
  }

  return children
}

function UnauthorizedRedirect() {
  useEffect(() => {
    toast.error('Admin access required')
  }, [])

  return <Navigate to="/dashboard" replace />
}

function FeatureDisabledRedirect() {
  useEffect(() => {
    toast.error('Feature currently disabled')
  }, [])

  return <Navigate to="/dashboard" replace />
}

export default ProtectedRoute


